var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBirbankFormenu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#F45369"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.288 4.311-4.805 4.803A1.65 1.65 0 0 0 13 10.28V26.9a.414.414 0 0 0 .712.296l4.805-4.803A1.648 1.648 0 0 0 19 21.227V4.607a.413.413 0 0 0-.712-.296Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBirbankFormenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/birbank-formenu.7682521547acfb0ff19537fa0c7c513b.svg";